import { Link } from "@chakra-ui/react"

const DesktopLink = ({ children, ...rest }) => {
	return (
		<Link
			mx={8} href="#"
			fontSize={['16px', null, null, '20px']}
			cursor="pointer"
			fontFamily="FiraSansMedium"
			color="#FDF6DC"
			textTransform="uppercase"
			_focus={{
				boxShadow: 'none'
			}}
			{...rest}
		>
			{children}
		</Link>
	)
}

export default DesktopLink
